import { render, staticRenderFns } from "./DesignRadioButton.vue?vue&type=template&id=9772dffc&scoped=true&"
import script from "./DesignRadioButton.vue?vue&type=script&lang=js&"
export * from "./DesignRadioButton.vue?vue&type=script&lang=js&"
import style0 from "./DesignRadioButton.vue?vue&type=style&index=0&id=9772dffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9772dffc",
  null
  
)

export default component.exports